<template>
  <div class="tb-form-group">
    <label class="tb-label layer-name">{{element.name}}</label>

    <div class="tb-form-group">
      <label class="tb-label">Cycle time</label>

      <input
        class="tb-input"
        type="number"
        data-test="graphics-editor-slideshow-timer"
        v-model="cycleTime"
      />
    </div>

    <div class="tb-form-group">
      <div class="tb-checkbox">
        <input
          id="hasProgressIndicator"
          type="checkbox"
          v-model="hasProgressIndicator"
          data-test="graphics-editor-slideshow-progressToggle"
        />

        <label class="checkbox" for="hasProgressIndicator">Add progress indicator</label>
      </div>
    </div>

    <div class="tb-form-group" v-if="hasProgressIndicator">
      <div class="tb-checkbox">
        <select
          v-model="progressIndicator.progressIndicatorStyle"
          class="tb-select"
          data-test="graphics-editor-slideshow-progressStyle"
        >
          <option value="stories">Stories</option>
          <option value="single">Slide progress bar</option>
        </select>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  props: ['element', 'graphic_fields'],

  computed: {
    cycleTime: {
      get() {
        return this.elementFields?.cycleTime ?? 5e3;
      },

      set(value) {
        this.updateField('cycleTime', value);
      },
    },

    hasProgressIndicator: {
      get() {
        return this.elementFields?.hasProgressIndicator ?? false;
      },

      set(value) {
        this.updateField('hasProgressIndicator', value);
      },
    },

    progressIndicator: {
      get() {
        return this.elementFields?.progressIndicator ?? {
          progressIndicatorStyle: 'stories',
        };
      },

      set(value) {
        this.updateField('progressIndicator.progressIndicatorStyle', value);
      },
    },

    elementFields() {
      return this.graphic_fields[this.element.id];
    },
  },

  methods: {
    updateField(field, value) {
      this.$emit('value', { field, value });
    },
  },
};
</script>
